import { render, staticRenderFns } from "./MessageBoxPopup.vue?vue&type=template&id=77b52fb2"
import script from "./MessageBoxPopup.vue?vue&type=script&lang=js"
export * from "./MessageBoxPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports